import { defineStore } from 'pinia'
import { api } from './api'
import { sleep } from '@/utils'

export const useLoadingStore = defineStore({
  id: 'loading',
  state: () => ({
    visible: false,
  }),
  actions: {
    $showLoading() {
      this.$state.visible = true
    },
    $hideLoading() {
      this.$state.visible = false
    },
  },
})

export const useToastStore = defineStore({
  id: 'toast',
  state: () => ({
    message: '',
  }),
  actions: {
    async $toast(message: string, duration = 1500) {
      this.message = message
      await sleep(duration)
      this.message = ''
    },
  },
})

// 按照章节切换维度上报

export const useConfigStore = defineStore({
  id: 'config',
  state: () => ({
    _fetched: false,
    // Start: 阅读配置
    /** 单页阅读最大时间, 超出该值, 取改值 seconds */
    pageReadTimeMax: 0,
    /** 单页阅读最小时间, 小于该值, 不计算 seconds */
    pageReadTimeMin: 0,
    /** 单章阅读最小时间, 单章阅读低于该值, 不算有效阅读, 不上报, seconds */
    chapterReadTimeMin: 0,
    /** 连续滑动X页, 且每一页时间小于单页最小时长 展示认真阅读提示toast */
    alertUnusualContinueTurnPage: 0,
    // End: 阅读配置

    // Start: 广告配置
    /** 插屏广告页展示形式, 1: 视频/ 2: 图片 */
    displayForm: 1,
    /** 插屏广告页播放完成动作, 1: 停留当前页, 2: 展示下一页 */
    playBackStatus: 1,
    /** 展示插屏广告页间隔次数, 用户滑动该值展示插屏广告 */
    displayIntervals: 0,
    /** 插屏广告页停留时长(秒), 插屏广告页停留时长 */
    pageDwellTime: 0,
    // 膨胀系数
    timeDilationCoefficient: 1,
    // Note: 插屏广告 文案显示, 需要存在前端本地, 例如: 20 分钟之内不在显示插屏广告
    /** 看视频免插屏广告时长, 看激励视频，免X分钟插屏广告展示 */
    // Note: 20 - 5
    /** 随机减少免插屏广告时长 */
    // End: 广告配置

    // Start: 赠送福利配置
    // 区分新用户, 老用户
    /** 插屏广告页展示福利间隔次数 例如配置 5, 那么第六个插屏广告 就是福利广告(激励视频) */
    adPopupDisplayFuliIntervalNum: 0,
    /** 插屏广告页福利奖励每日次数上限, 如果达到上限，跳过上面的逻辑 */
    adPopupFuliDailyInspireMax: 0,
    /** 每日阅读奖励双倍次数上限(激励视频), 双倍弹窗显示上限 */
    readDailyInspireDoubleNumMax: 0,

    // 兜底
    indexDailyPopupCoin: 0,
    adPopupFuliInspireNum: 0,
    readDailyInspireDoubleCoin: 0,
    // End: 赠送福利配置
    // 看视频免广告时长, 分钟
    freeTime: 0,
    sourceFreeTime: 0,
  }),
  actions: {
    async init(options: { force: boolean } = { force: false }) {
      if (this.$state._fetched && !options.force)
        return
      const { data } = await api.get<null, GetKuaishouConfigGetResponse>('/kuaishou/config/get')
      this.$state = { ...this.$state, ...data, _fetched: true } as any
    },
  },
})

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    _fetched: false,
  }),
  actions: {
    async init(options: { force: boolean } = { force: false }) {
      if (this.$state._fetched && !options.force)
        return
      const data = {}
      this.$state = { ...this.$state, ...data, _fetched: true } as any
    },
  },
})
